// Service for label API
export default class LabelsService {
  static async fetchLabels(calendarId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/labels/calendar/${calendarId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch labels: ${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async createLabel(label, token) {
    const apiUrl = window.env.API_URL;
    console.log('Creating label with data:', label); // Debug log
    const response = await fetch(`${apiUrl}/api/v1/labels`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(label),
    });
    if (!response.ok) {
      throw new Error(`Failed to create label: ${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async updateLabel(id, label, token) {
    const apiUrl = window.env.API_URL;
    console.log('Updating label with ID:', id, 'and data:', label); // Debug log
    const response = await fetch(`${apiUrl}/api/v1/labels/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(label),
    });
    if (!response.ok) {
      throw new Error(`Failed to update label: ${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async deleteLabel(id, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/labels/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to delete label: ${response.status} ${response.statusText}`);
    }
    return true;
  }

  static async fetchLabel(id, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/labels/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch label');
    return response.json();
  }
}
